import React, { useEffect } from "react";
import Modal from "../../../../../ReusableComponents/Modal";
import Loading from "../../../../../ReusableFunctions/Loader";
import { updateDspGstin, updateUserData } from "../../../../../apis/users";
import Popup from "../../../../../ReusableFunctions/Popup";
import { Button } from "../../../../../Components/Helper";
import InputField from "../../../../../ReusableComponents/InputField";
import { gstinValidation } from "../../../../../utils/inputValidations";
import Form from "../../../../../ReusableComponents/Form";

const EditGSTIN = ({ user, open, onClose, onUserUpdate }) => {
  let isEdit = false;
  const updateProfileInfo = async (gstin) => {
    Loading.set(true);
    try {
      await updateDspGstin({
        ...user?.dsp,
        gstin: gstin ? gstin.toUpperCase() : "",
      })
        .then((res) => {
          console.log("Updated DSP:", res);
          onUserUpdate({
            ...user,
            dsp: {
              ...user?.dsp,
              gstin: gstin ? gstin.toUpperCase() : "",
            },
          });
          Loading.set(false);
          Popup.alert(
            `${!isEdit ? "GSTIN Added!" : "GSTIN Updated!"}`,
            <p>
              {!isEdit
                ? "Your GSTIN added successfully!"
                : "Your GSTIN updated successfully!"}
            </p>,
            "SUCCESS",
            () => {},
          );
        })
        .catch((e) => {
          Loading.set(false);
          console.log(e);
          Popup.alert("Profile", e, "ERROR", () => {});
        });
    } catch (e) {
      Loading(false);
      console.log(e);
      Popup.alert(
        "GSTIN Number",
        "Something went wrong while updating GSTIN number",
        "ERROR",
        () => {},
      );
    }
  };

  useEffect(() => {
    isEdit = user?.dsp?.gstin ? true : false;
  }, []);

  return (
    <Modal
      header={user?.dsp?.gstin ? "Tax ID" : "Tax ID"}
      open={open}
      onClose={onClose}
      contentStyle={{ width: "534px", height: "auto" }}
      divider={true}
      headingStyle={{ fontSize: "18px" }}
      iconSize={"18px"}
      headerContainerStyle={{ padding: "20px 40px" }}
    >
      <Form
        onSubmitForm={(data) => {
          updateProfileInfo(data.gstin || "");
        }}
        initialValues={{ gstin: user?.dsp?.gstin || "" }}
      >
        {(onSubmit) => (
          <>
            <div style={{ padding: "15px 46px" }}>
              {/* <p style={{ paddingBottom: "17px", fontSize: '16px', color: '#1e1e1e', fontWeight: 500 }}>
                                Enter GSTIN number
                            </p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.5rem",
                }}
              >
                <InputField
                  key={user?.dsp?.gstin || "empty"}
                  label={"Tax ID"}
                  name={"gstin"}
                  placeholder={"Enter Tax ID"}
                  required={false}
                  style={{
                    height: "51px",
                    borderRadius: "8px",
                    padding: "2px 15px",
                  }}
                  inputStyle={{ fontSize: "16px" }}
                  labelStyle={{
                    paddingBottom: "7px",
                    fontSize: "16px",
                    color: "#3b3b3b",
                    fontWeight: "400",
                  }}
                  validation={{
                    validate: (value) => {
                      if (!value) return true; // optional field
                      const error = gstinValidation(value);
                      return error === "" ? true : error;
                    },
                  }}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row-reverse",
                padding: "0px 48px 22px 122px",
                gap: "20px",
              }}
            >
              <Button
                text={user?.dsp?.gstin ? "Update" : "Add"}
                onClick={() => {
                  onSubmit();
                }}
                style={{ width: "141px", height: "47px", fontSize: "16px" }}
              />
              <Button
                type={"button"}
                onClick={() => {
                  onClose();
                }}
                text={"Cancel"}
                isBtnNotActive={true}
                style={{
                  width: "141px",
                  height: "47px",
                  fontSize: "16px",
                  marginRight: "5px",
                }}
              />
            </div>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default EditGSTIN;
